import React, { useContext } from "react";
import { FilterContext } from "../FilterContextProvider";
import Logout from "../Auth/Logout";

const ArtistsLayout = ({ children }) => {
  const { filterData } = useContext(FilterContext);

  return (
    <div className="text-black ml-24 h-14 border-b bg-white">
      <div className="flex flex-row mb-4 text-sm text-black h-14">
        {filterData.artist_name && (
          <div className="bg-blue-500 text-white h-14 flex p-4 font-semibold">
            {filterData.artist_name}
          </div>
        )}
        <Logout></Logout>
      </div>
      <div className="bg-gray-100 pt-2 pb-8">{children}</div>
    </div>
  );
};

export default ArtistsLayout;
